<template>
  <div class="orglisting">
    <app-layout class="advocay-template" >
      <!-- {{brandInfo}} -->
      <div style="display: flex; justify-content: center; flex-direction: column;" v-if="!isLoadingItems">
        <div class="featured-org">
          <Card v-if="featuredItems" style="border-radius:0" :padding="0" shadow >
            <p style="padding:10px 10px 0;color:#000;font-weight:bolder" align="center">Featured</p>
            <div v-if="featuredItems && featuredItems.length > 0">
              <div class="featured-items">
                <div
                  v-for="(featuredItem, i) in featuredItems"
                  :key="i"
                  @click="goToOrganization(featuredItem)"
                  class="pointer featured-card-wrapper"
                >
                  <Card dis-hover bordered>
                    <div class="card-content">
                      <div class="image-container">
                        <img :src="featuredItem.avatar" />
                      </div>
                    </div>
                  </Card>
                  <p class="org-name-wrapper">
                    <small>{{featuredItem.display_name}}</small>
                  </p>
                </div>
              </div>
            </div>
            <div v-else-if="featuredItems && featuredItems.length <= 0">
              <p class="empty-featured">No featured</p>
            </div>
          </Card>
        </div>
        <!-- <div class="other-org">
          <Card style="border-radius:0" :padding="0" shadow>
            <p style="padding:10px;color:#000;font-weight:bolder;" align="center">Featured</p>
            <div v-if="featuredItems && featuredItems.length > 0">
              <div v-for="(item, k) in featuredItems" :key="k">
                <ResourceListItemComponent
                  :item="item"
                  :title="item.display_name"
                  :avatar="item.avatar"
                ></ResourceListItemComponent>
              </div>
            </div>
            <div v-else-if="featuredItems && featuredItems.length <= 0">
              <div>
                <p class="empty-featured">No featured</p>
              </div>
            </div>
          </Card>
        </div>-->

        <div class="other-org" style="margin:10px 0" v-if="false">
          <Card v-if="getAllNearbyOrganizations" style="border-radius:0" :padding="0" shadow>
            <p style="padding:10px;color:#000;font-weight:bolder;" align="center">Nearby</p>
            <div v-if="getAllNearbyOrganizations.length > 0">
              <div v-for="(item, k) in getAllNearbyOrganizations" :key="k">
                <ResourceListItemComponent
                  :item="item"
                  :title="item.display_name"
                  :avatar="item.avatar"
                ></ResourceListItemComponent>
              </div>
            </div>
            <div v-else>
              <div>
                <p class="empty-featured">No nearby organization</p>
              </div>
            </div>
          </Card>
        </div>

        <div class="other-org" style="margin-top:10px">
          <Card v-if="getAllOrganizations" style="border-radius:0" :padding="0" shadow>
            <p style="padding:10px;color:#000;font-weight:bolder;" align="center">Nearby</p>
            <div v-if="getAllOrganizations && getAllOrganizations.length > 0">
              <div v-for="(item, k) in getAllOrganizations" :key="k">
                <ResourceListItemComponent
                  :item="item"
                  :title="item.display_name"
                  :avatar="item.avatar"
                ></ResourceListItemComponent>
              </div>
              <div v-if="hasNextOrganization" class="d-flex justify-content-center align-items-center" style="padding: 10px;">
                <Button @click="loadNextAllOrganizations" v-if="!isLoadingNextOrganization">Load More</Button>
                <Spin v-else>
                  <Icon type="load-c" class="demo-spin-icon-load"></Icon>
                  <div>Loading</div>
                </Spin>
              </div>
            </div>
            <div v-else-if="getAllOrganizations.length <= 0">
              <div>
                <p class="empty-featured">No organization</p>
              </div>
            </div>
          </Card>
        </div>
        
        <div class="other-org" style="margin-top:10px" v-if="false">
          <Card style="border-radius:0" :padding="0" shadow>
            <p style="padding:10px;color:#000;font-weight:bolder" align="center">Most Followed</p>
            <div
              v-if="mostOrganization && mostOrganization.doctors && mostOrganization.doctors.length > 0"
            >
              <div v-for="(item, k) in mostOrganization.doctors" :key="k">
                <ResourceListItemComponent
                  :item="item"
                  :title="item.display_name"
                  :avatar="item.avatar"
                ></ResourceListItemComponent>
              </div>
            </div>
            <div v-else>
              <div>
                <p class="empty-featured">No organization</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </app-layout>
  </div>
</template>

<script>
import _ from "lodash";
import ResourceListItemComponent from "@/components/ResourceMainAdvocaciesComponent";
import { setTimeout } from "timers";
import { mapGetters } from "vuex";
import { Message } from "iview";

export default {
  components: {
    ResourceListItemComponent
  },
  data() {
    return {
      isLoadingItems: false,
      mostOrganization: {},
      mostOrganizationLoading: false
    };
  },
  computed: {
    ...mapGetters("user", ["brandInfo", "isLoadingBrandTheme"]),
    ...mapGetters("org", [
      "getAllOrganizations",
      "hasNextOrganization",
      "isLoadingNextOrganization",
      "allNextPageUrl",
      "getAllNearbyOrganizations"
    ]),
    featuredItems() {
      return this.$store.state.org.organizations.featuredData.doctors;
    },
    userProfile() {
      return this.$store.state.user.info;
    }
  },
  watch: {
    isLoadingBrandTheme: function(n, o) {
      if (!n) this.loadOrganizations();
    }
  },
  mounted() {
    this.loadOrganizations();
  },
  methods: {
    async loadNextAllOrganizations() {
      try {
        await this.$store.dispatch("org/getNextAllOrganizations", this.allNextPageUrl)
      }
      catch(e) {
        Message.warning("Unable to load organizations");
      }
    },
    async loadOrganizations() {
      if (!this.userProfile || !this.userProfile.id) return false;

      try {
        this.$store.commit("base/setLoadingPage", true, { root: 1 });
        this.isLoadingItems = true

        await this.$store.dispatch("org/getFeaturedOrganizations", null, {
          root: 1
        });

        await this.$store.dispatch("org/getAllOrganizations")

        // if (this.userProfile.zipcode)
        //   await this.$store.dispatch(
        //     "org/getNearbyOrganizations",
        //     this.userProfile.zipcode,
        //     { root: 1 }
        //   );

        // await this.$store.dispatch("org/getMostOrganizations")
        //   .then(res => {
        //     this.mostOrganization = res;
        //   })
      } finally {
        this.$store.commit("base/setLoadingPage", false, { root: 1 });
        this.isLoadingItems = false
      }
    },
    goToOrganization(org) {
      this.$store.commit("resource/setSingleGroup", org);
      this.$router.push({
        path: "/organization/" + org.careplan_id,
        query: {
          tab: "home"
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.featured-items {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}
.org-name-wrapper {
  font-size: 18px;
  width: 100%;
  text-align: center;
  background: white;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 54px;
}

/deep/.featured-card-wrapper {
  display: flex;
  padding: 10px;
  flex-direction: column;
  width: 50%;
  justify-content: center;
  align-items: center;
  .ivu-card {
    width: 100%;
  }
  .ivu-card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
    height: 50%;

    .card-content {
      width: 100%;
      padding-top: 100%;
      position: relative;
      .image-container {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0px;
        img {
          object-fit: cover;
          width: 100%;
          height: 100%;
        }
      }
    }
    // img {
    //   object-fit: cover;
    //   width: ;
    //   height: 160px;
    //   border-radius: 4px 4px 0 0;
    // }
    p {
      margin-top: 8px;
    }
  }
}
.loader {
  display: flex;
  height: 80vh;
  justify-content: center;
  align-items: center;
  i {
    animation: ani-demo-spin 1s linear infinite;
    height: 20px;
  }
}
.error-text {
  text-align: center;
  width: 100%;
  margin-top: 8px;
}

.error-wrapper {
  display: flex;
  height: 80vh;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.featured-org,
.other-org {
  width: 100%;
  //   background: #ffffff;
  > span {
    padding: 10px 10px;
    display: block;
  }
}
.empty-featured {
  padding: 10px;
  color: #aaa;
  background: white;
  height: 60px;
  line-height: 40px;
  text-align: center;
}
</style>

<style>
@media (min-width: 768px)  {
  .featured-card-wrapper {
    width: 33.333% !important;
  }
}
</style>
